// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--BUyOK","icon":"_7a3fb80146--icon--bCs0y"};